export const preprocessImage = (
  url: string,
  height: number,
  width?: number,
) => {
  if (!url) return '';
  const urlSearchParams = `x-oss-process=image/resize,m_pad,h_${height},w_${width ?? height}/format,webp`;
  return url
    .replace('cut-img', 'origin-img')
    .split('?')[0]
    .concat('?')
    .concat(urlSearchParams);
};
